import { enrich } from '../../helpers';

// eslint-disable-next-line import/prefer-default-export
export function selectGamePlans(slice, teamId) {
  return slice?.teamGameplans?.[teamId] || enrich();
}
